export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_DOCTORS_REQUEST = "FETCH_DOCTORS_REQUEST";
export const FETCH_DOCTORS_COUNT_REQUEST = "FETCH_DOCTORS_COUNT_REQUEST";
export const CREATE_DOCTOR_REQUEST = "CREATE_DOCTOR_REQUEST";
export const CREATE_DOCTORS_BY_CSV_FILE_REQUEST = "CREATE_DOCTORS_BY_CSV_FILE_REQUEST";
